import type { PlatformAdapter } from "./PlatformAdapter.js";
import { FacebookPlatformAdapter } from "./facebook.js";
import { WebPlatformAdapter } from "./web.js";

export type { PlatformAdapter, AuthResult } from "./PlatformAdapter.js";

// `typeof FBInstant !== "undefined"` alone is NOT enough: the SDK script
// (loaded unconditionally in index.html) defines the full window.FBInstant
// object even in a plain top-level browser tab outside any Facebook host —
// it's not the no-op that comment assumed. Calling initializeAsync() there
// hangs forever waiting for a host handshake that never arrives (verified
// live — standalone web got stuck on the loading screen). Real Instant
// Games are always embedded in an iframe by Facebook/Messenger, so also
// require top !== self to tell a real FB host apart from a standalone tab.
export function isFacebookEmbed(): boolean {
  return window.top !== window.self && typeof FBInstant !== "undefined";
}

export function detectPlatformAdapter(): PlatformAdapter {
  return isFacebookEmbed() ? new FacebookPlatformAdapter() : new WebPlatformAdapter();
}
